import React from 'react';
import './styles/style.scss';
import Whele from './components/whele';
import AboutMe from './components/aboutMe';
import Contacts from './components/contacts';
import Talents from './components/talents';
import Projects from './components/projects';

class App extends React.Component{
	constructor(props){
		super(props);

		this.state = {
			lastPage: 0,
			page: 0,
			isMobile: window.innerHeight/window.innerWidth > 1.2,
		}

		this.destructors = [];
	}

	componentDidMount(){
		const onResize = this.onResize.bind(this);
		window.addEventListener("resize", onResize);
		this.destructors.push(()=>{
			window.removeEventListener("resize", onResize);
		})
	}

	componentWillUnmount(){
		this.destructors.forEach(e=>e());
	}

	onResize(){
		this.setState({isMobile: window.innerHeight/window.innerWidth > 1.2})
	}
	
	setPage(page){
		this.setState({lastPage: this.state.page, page});

		setTimeout(() => {
			this.setState({lastPage: this.state.page});
		}, 250);
	}
	
	render(){
		return (
			<div className="app">
				<Whele setPage={this.setPage.bind(this)} isMobile={this.state.isMobile}/>
				<AboutMe visible={this.state.page == 0} wasVisible={this.state.lastPage == 0} isMobile={this.state.isMobile}/>
				<Talents visible={this.state.page == 1} wasVisible={this.state.lastPage == 1} isMobile={this.state.isMobile}/>
				<Projects visible={this.state.page == 2} wasVisible={this.state.lastPage == 2} isMobile={this.state.isMobile}/>
				<Contacts/>
			</div>
		)
	}
}

export default App;
